  <template>
  <div id="WeeklyRentalReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>

    <div id="page-content-wrapper" class="admin-content-area" >
       <template v-if="cantAccessPage === true">
          <div class="page-name">
            <div class="page-title">Weekly Rental Report</div>
            <div class="web-action-btn btn-groups text-right">
                <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                    <i class="fp-export"></i> Export
                </a>
            </div>
          </div>
          <div class="container-fluid">
            <div class="admin-page-content contact-list">
              <data-table-filter-config :moduleName="'weeklyRentalReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
              <div class="data-table bg-white overflow-hidden">
                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                <section class="bg-white data-table">
                    <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange" :moduleName="'weeklyRentalReport'" :position="'top'">
                    </custom-pagination>

                    <vue-good-table
                        ref="weeklyRentalReportTable"
                        mode="remote"
                        title="Reservations"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        :totalRows="totalRecords"
                        :columns="userColumns"
                        :rows="rows"
                        :isLoading=false
                        :paginationOptions="{
                            enabled: false,
                            position: 'both',
                            perPage: perPage,
                            dropdownAllowAll: false,
                            setCurrentPage:listCurrentPage,
                            perPageDropdown:dropDownPerPage,
                        }"
                        :search-options="{
                        enabled: false,
                        }"
                        >
                    </vue-good-table>
                    <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange">
                    </custom-pagination>
                </section>
              </div>
            </div>
          </div>
       </template>
       <template v-else-if="cantAccessPage === false">
          <div class="container-fluid">
              <div class="bg-white text-center">
                  <h1>
                      Oops!</h1>
                  <h2>
                      403 </h2>
                  <div class="error-details">
                      Sorry!, You don't have permission to access this page.
                  </div>
              </div>
          </div>
      </template>
      <template v-else>
          <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {
  name: "WeeklyRentalReport",
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
      cantAccessPage:"",
      loading: false,
      action: "list",
      permissions:[],
      rows: [],
      totalRecords: 0,
      userColumns:[],
      columns:[
      {
        label: "Unit Number",
        field: "unit_no",
        fpFieldType:"text",
        filterable: true,
        hidden:false,
        width: '90px',
      },
      {
        label: "Customer Name",
        field: "customer",
        fpFieldType:"text",
        filterable: true,
        hidden:false,
      },
      {
          label: 'Agreement Type',
          field: 'agreement_type',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "All", // placeholder for filter input
              filterDropdownItems: ['RC'],
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false,
      },
      {
          label: 'Agreement Number',
          field: 'agreement_no',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Account Manager',
          field: 'account_manager',
          hidden:false,
          filterable: false,
          fpFieldType:"text",
          sortable: false,
      },
      {
        label: "Rental Start Date",
        field: "due_out_datetime",
        filterable: true,
        fpFieldType:"custom_date",
        hidden:false,
      },
       {
        label: "Rental Termination Date",
        field: "due_in_datetime",
        fpFieldType:"custom_date",
        filterable: true,
        hidden:false,
      },
      {
            label: "Facility Code",
            field: 'assigned_facility',
            fpFieldType:"option",
            hidden:false,
            filterable: true,
      },
      {
            label: "Renting Branch",
            field: 'location_desc',
            fpFieldType:"option",
            hidden:false,
            filterable: true,
      },
      {
           label: "Agreement Sts",
           field: "status",
           filterable: true,
           fpFieldType:"option",
           hidden:false,
           filterOptions: {
               enabled: false, // enable filter for this column
              placeholder: "All", // placeholder for filter input
              filterDropdownItems: ["Active","Pending","Expired"],
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //
           }
      },
      {
           label: "Equipment Master Status",
           field: "vehicle_status",
           filterable: true,
           fpFieldType:"option",
           hidden:false,
           filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "All", // placeholder for filter input
              filterDropdownItems: ['Active(A)','In Garage(I)','Sold(S)','Void(V)'],
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //
           }
      },
      {
          label: 'Equipment Type',
          field: 'asset_type',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Equipment Pool',
          field: 'asset_pool',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
        label: "User ID Rental Out",
        field: "created_by",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
        label: "User ID Rental Return",
        field: "ra_updated",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
      },
      {
          label: 'Fixed Rate Daily',
          field: 'fRate_daily',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Fixed Rate Weekly',
          field: 'fRate_weekly',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Fixed Rate Monthly',
          field: 'fRate_monthly',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Distance Daily Rate',
          field: 'dRate_daily',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Distance Weekly Rate ',
          field: 'dRate_weekly',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Distance Monthly Rate',
          field: 'dRate_monthly',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Reefer Daily Rate',
          field: 'rRate_daily',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Reefer Weekly Rate ',
          field: 'rRate_weekly',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Reefer Monthly Rate',
          field: 'rRate_monthly',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false

      },
      {
          label: 'ENV Daily Rate',
          field: 'eRate_daily',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false

      },
      {
          label: 'ENV Weekly Rate ',
          field: 'eRate_weekly',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false

      },
      {
          label: 'ENV Monthly Rate',
          field: 'eRate_monthly',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false

      },
      {
          label: 'INSPD Daily Rate',
          field: 'inRate_daily',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false

      },
      {
          label: 'INSPD Weekly Rate ',
          field: 'inRate_weekly',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false

      },
      {
          label: 'INSPD Monthly Rate',
          field: 'inRate_monthly',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false

      },
      {
          label: 'INSPL Daily Rate',
          field: 'ilRate_daily',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false

      },
      {
          label: 'INSPL Weekly Rate ',
          field: 'ilRate_weekly',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false

      },
      {
          label: 'INSPL Monthly Rate',
          field: 'ilRate_monthly',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Customer Purchase Order',
          field: 'po',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Contract Type',
          field: 'contract_type',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
       {
          label: 'Contract Scope',
          field: 'contract_scope',
          hidden:false,
          filterable: false,
          fpFieldType:"text",
          sortable: false
      },
      {
          label: 'Replaced Unit',
          field: 'replaced_unit',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Replaced Reason',
          field: 'replaced_reason',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
          // sortable:false
      },
      {
          label: 'Equipment Type Description ',
          field: 'equip_type_desc',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Out Facility Code',
          field: 'location',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Intended Use',
          field: 'intended_use',
          hidden:false,
          filterable: false,
          fpFieldType:"text",
          sortable : false
      },
      {
          label: 'Customer Number',
          field: 'customer_no',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Scope Name',
          field: 'scope_name',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'EngineHours Daily Rate',
          field: 'eHrs_daily',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'EngineHours Weekly Rate',
          field: 'eHrs_weekly',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable: false
      },
      {
          label: 'EngineHours Monthly Rate',
          field: 'eHrs_monthly',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Start Date',
          field: 'start_date',
          fpFieldType:"text",
          filterable: false,
          sortable:false,
          fpMandatory:true,
          hidden:true,
      },
      {
          label: 'End Date',
          field: 'end_date',
          fpFieldType:"text",
          filterable: false,
          sortable:false,
          fpMandatory:true,
          hidden:true,
      }

      ],
      batchProcess:0,
      batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'weekly_rental_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    cancelAll: function (cancelAll) {
        this.$refs.weeklyRentalReportTable.unselectAllInternal();
    },
    // exportReports: function() {
    //     var self = this;
    //     this.action = "export";
    //     this.loadList();
    // },
    loadList: function(){


      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();
      $.ajax({
        url: process.env.ROOT_API + "/weekly-rental-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action

        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          if (data.status == "success") {
             if (self.action == "export" ||  self.action == "export_queue") {
                if ( data.code == "201" ) {
                    alert(data.message);
                } else {
                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);
                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }
                }

              self.action = "list";
              self.loadList();

            } else  {
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;

            }

          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'reservation-list-booking')
        }
      });

    }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/WeeklyRentalReport.vue